import React, { useContext, useEffect, useState } from 'react'
import SocialNetworkSidePanel from 'views/calendar/SocialNetworkSidePanel';
import { useParams, useNavigate } from 'react-router-dom';
import ImagesTemplate from './templates/ImagesTemplate';
import NewsTemplate from './templates/NewsTemplate';
import GoogleTemplate from './templates/GoogleTemplate';
import CalendarTemplate from './templates/CalendarTemplate';
import BrainstormTemplate from './templates/BrainstormTemplate';
import QuestionsTemplate from './templates/QuestionsTemplate';
import RawTemplate from './templates/RawTemplate';
import URLTemplate from './templates/URLTemplate';
import ToolHeader from './ToolHeader';
import usePostGenerator from 'utils/hooks/usePostGenerator';
import { CompanyContext } from 'contexts/CompanyContext';
import { Container } from 'components/shared';
import PostArticles from 'views/posts/PostArticles';
import { LuBrainCircuit, LuCalendarDays, LuImage, LuLink2, LuNewspaper, LuScrollText, LuTextCursorInput } from 'react-icons/lu';
import { BsStars } from 'react-icons/bs';
import { TbBrandGoogle, TbMessage, TbZoomQuestion } from 'react-icons/tb';
import useConfigPanel from 'utils/hooks/useConfigPanel';
import PromptTemplate from './templates/PromptTemplate';
import SuggestTemplate from './templates/SuggestTemplate';
import ChatTemplate from './templates/ChatTemplate';
import { CompanyPromptsContext } from 'contexts/CompanyPromptsContext';
import useBrainstormContexts from 'utils/hooks/useBrainstormContexts';
import { ScheduledPostContext } from 'contexts/ScheduledPostContext';
import Lottie from 'react-lottie';
import generationAnimation from 'assets/animations/generation-posts.json';
import generationAnimationWhitelabel from 'assets/animations/generation-posts-whitelabel.json';
import { Card, Badge, Button, Progress } from 'components/ui';
import { Trans } from 'react-i18next';
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';
import { AIContext } from 'contexts/AIContext';
import { useGeneration } from 'contexts/GenerationContext';
import { contextToText } from 'utils/hooks/useCopyGenerator';
import { stripHTMLReplaceWithNewLines } from 'utils/stripHTML';

export const tools = [
    {
        id: "suggest",
        title: `ai_templates.title_suggest`,
        short_title: `AI Suggestions`,
        description: `ai_templates.description_suggestions`,
        long_description: `suggestionsTemplate.longDescription`,
        buttonTitle: `ai_templates.button_label_images`,
        emoji: "✨",
        hideHeader: true,
        icon: <BsStars />,
        learn_more: "",
        component: SuggestTemplate
    },
    {
        id: "prompt",
        title: `ai_templates.title_prompt`,
        short_title: `From Prompt`,
        description: `ai_templates.description_prompt`,
        long_description: `promptTemplate.longDescription`,
        buttonTitle: `ai_templates.button_label_prompt`,
        emoji: "🤖",
        hideHeader: true,
        icon: <LuTextCursorInput />,
        learn_more: "",
        component: PromptTemplate,
    },
    {
        id: "chat",
        title: `ai_templates.title_chat`,
        short_title: `From Chat`,
        description: `ai_templates.description_chat`,
        long_description: `urlTemplate.followrAnalyzes`,
        buttonTitle: `ai_templates.button_label_chat`,
        emoji: "💬",
        icon: <TbMessage />,
        hideHeader: true,
        learn_more: "",
        component: ChatTemplate
    },
    {
        id: "images",
        title: `ai_templates.title_images`,
        short_title: `From Images`,
        description: `ai_templates.description_images`,
        long_description: `imagesTemplate.generateNewIdeas`,
        buttonTitle: `ai_templates.button_label_images`,
        emoji: <img src="/img/others/images-3d.png" className='h-full !max-h-[48px] mx-auto' />,
        icon: <LuImage />,
        learn_more: "",
        component: ImagesTemplate
    },
    {
        id: "news",
        title: `ai_templates.title_news`,
        short_title: `From News`,
        description: `ai_templates.description_news`,
        long_description: `newsTemplate.selectUpTo`,
        buttonTitle: `ai_templates.button_label_news`,
        emoji: "🗞️",
        icon: <LuNewspaper />,
        learn_more: "",
        component: NewsTemplate
    },
    {
        id: "holidays",
        title: `ai_templates.title_holidays`,
        short_title: `From Holidays`,
        description: `ai_templates.description_holidays`,
        long_description: `calendarTemplate.chooseSpecialDays`,
        buttonTitle: `ai_templates.button_label_holidays`,
        emoji: "🗓",
        icon: <LuCalendarDays />,
        learn_more: "",
        component: CalendarTemplate
    },
    {
        id: "google",
        title: `ai_templates.title_google`,
        short_title: `From Google`,
        description: `ai_templates.description_google`,
        long_description: `googleTemplate.createContentBasedOn`,
        buttonTitle: `ai_templates.button_label_google`,
        emoji: <img src="/img/others/google.png" className='h-full !max-h-[48px] mx-auto' />,
        icon: <TbBrandGoogle />,
        learn_more: "",
        component: GoogleTemplate,
        // needUpgrade: ['free'],
    },
    {
        id: "brainstorm",
        title: `ai_templates.title_brainstorm`,
        short_title: `From Brainstorm`,
        description: `ai_templates.description_brainstorm`,
        long_description: `brainstormTemplate.generateNewIdeas`,
        buttonTitle: `ai_templates.button_label_brainstorm`,
        emoji: "🧠",
        icon: <LuBrainCircuit />,
        learn_more: "",
        component: BrainstormTemplate,
        // needUpgrade: ['free'],
    },
    {
        id: "questions",
        title: `ai_templates.title_questions`,
        short_title: `From Questions`,
        description: `ai_templates.description_questions`,
        long_description: `questionsTemplate.followrGuidesYou`,
        buttonTitle: `ai_templates.button_label_questions`,
        emoji: "🤔",
        icon: <TbZoomQuestion />,
        learn_more: "",
        component: QuestionsTemplate,
        // needUpgrade: ['free'],
    },
    {
        id: "raw",
        title: `ai_templates.title_raw`,
        short_title: `From Raw Text`,
        description: `ai_templates.description_raw`,
        long_description: `rawTemplate.improveAdapt`,
        buttonTitle: `ai_templates.button_label_raw`,
        emoji: "📜",
        icon: <LuScrollText />,
        learn_more: "",
        component: RawTemplate,
        // needUpgrade: ['free'],
    },
    {
        id: "url",
        title: `ai_templates.title_url`,
        short_title: `From URLs`,
        description: `ai_templates.description_url`,
        long_description: `urlTemplate.followrAnalyzes`,
        buttonTitle: `ai_templates.button_label_url`,
        emoji: "🔗",
        icon: <LuLink2 />,
        learn_more: "",
        component: URLTemplate,
        // needUpgrade: ['free'],
    },
];

const Playground = ({
    forceTemplate = ""
}) => {  
    let { template } = useParams();
    if (forceTemplate) template = forceTemplate;
    const tool = tools.find(e => e.id == template);
    const SelectedToolComponent = tool?.component;
    const navigate = useNavigate();

    const [ config, setConfig ] = useState();
    const [ previousContexts, setPreviousContexts ] = useState([]);
    const { isWhitelabel } = useWhitelabel();
    const { imageTypes, postTypes, getDefaultImageTypePerTemplate } = useConfigPanel(template, config?.postType);
    const { company } = useContext(CompanyContext);
    const { aiModels } = useContext(AIContext);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ posts, setPosts ] = useState([]);
    const [ lastContexts, setLastContexts ] = useState(false);
    const [ lastImages, setLastImages ] = useState(false);
    const [ lastQuantity, setLastQuantity ] = useState();
    const { generateFromContext } = usePostGenerator();
    const { defaultPrompts } = useContext(CompanyPromptsContext); 
    const { getBrainstormContexts } = useBrainstormContexts();
    const { scheduledPosts } = useContext(ScheduledPostContext);
    const {
        activeGeneration,
        startGeneration,
        updateGenerationProgress,
        completeGeneration,
        cancelGeneration,
        clearGeneration
    } = useGeneration();

    // Earlier copies of a context, so "generate more" asks for different ones.
    const maxAvoidCopies = 5;
    const maxAvoidCopyLength = 600;

    // A context is a string (the topic) or an object ({ brief, source, link }) from the templates.
    const handleOnGeneratePostsFromContext = async (contexts = [], images = [], quantity = 1, generateMore = false) => {
        console.log('=== FUNCTION START ===');
        console.log('Input contexts:', contexts);
        console.log('Input quantity:', quantity);
        console.log('generateMore:', generateMore);
        
        setIsLoading(true);
        
        // Store original contexts BEFORE any processing (only for new generations)
        if (!generateMore) {
            clearGeneration();
            setLastContexts(contexts);
            setLastImages(images);
            setLastQuantity(quantity);
            console.log('New Generation - storing ORIGINAL contexts:', contexts, 'quantity:', quantity);
        }
        
        // Handle generate more case
        if (generateMore) {
            contexts = lastContexts;
            images = lastImages;
            quantity = lastQuantity;
            console.log('Generate More - using stored contexts:', contexts, 'quantity:', quantity);
        }
        
        contexts = Array.isArray(contexts) ? contexts : [];
        images = Array.isArray(images) ? images : [];
        quantity = Math.max(1, parseInt(quantity) || 1);

        if (!contexts.map(contextToText).join(``).trim()) {
            try {
                let randomTopic = (company?.interests || []).random() || ``;
                let randomContexts = await getBrainstormContexts(randomTopic, 15, previousContexts, false);
                randomContexts.length = contexts.length;
                contexts = randomContexts;
                setPreviousContexts(contexts);
            } catch (err) {}
        } else {
            setPreviousContexts([]);
        }

        // Each context asks for `quantity` variations in one batch, so images[index] stays aligned
        // with contexts[index]. Generate more makes one more post per context.
        const postsPerContext = generateMore ? 1 : quantity;

        console.log('Final contexts for generation:', contexts, 'length:', contexts?.length, 'posts per context:', postsPerContext);

        if (contexts?.length) {
            // Start or continue generation tracking
            let generationId;
            if (!generateMore) {
                // New generation: one expected post per variation
                generationId = startGeneration(template, config, contexts.flatMap(i => Array(postsPerContext).fill(i)));
            } else {
                // Generate more - create new tracking with total expected posts
                const existingPosts = posts || [];
                const expectedNewPosts = contexts.length * postsPerContext; // Number of new posts we'll generate
                const totalExpectedPosts = existingPosts.length + expectedNewPosts;

                // Create a mock contexts array that represents the total expected posts
                const totalContexts = Array(totalExpectedPosts).fill('post');
                generationId = startGeneration(template, config, totalContexts);
                // Immediately update with existing posts as already completed
                updateGenerationProgress(existingPosts, true);
            }

            const instructions = {
                tone: config?.tone,
                format: config?.format,
                cta: config?.cta,
                extra_instructions: config?.extraInstructions
            };

            // Generate more: continue the variation angles after the posts this context already
            // has, and pass their copies so the new ones differ.
            const previousForContext = (index) => generateMore
                ? (posts || []).filter(p => p?.contextIndex === index)
                : [];

            // Posts generated so far, shown as each context's batch resolves
            const progressPosts = generateMore ? [...(posts || [])] : [];

            try {
                const results = await Promise.allSettled(
                    contexts.map(async (context, index) => {
                        const previous = previousForContext(index);
                        const result = await generateFromContext(
                            config?.postType, 
                            context, 
                            instructions,
                            images?.[index] ? [images[index]] : [],
                            config?.imageType,
                            undefined,
                            config?.prompts,
                            postsPerContext,
                            {
                                offset: previous.length,
                                avoid: previous
                                    .slice(-maxAvoidCopies)
                                    .map(p => stripHTMLReplaceWithNewLines(p?.posts?.[0]?.description).trim().substring(0, maxAvoidCopyLength))
                                    .filter(Boolean),
                                contextIndex: index
                            }
                        );

                        // Update progress after each context's posts are generated
                        progressPosts.push(...(result?.flat() || []));

                        updateGenerationProgress([...progressPosts], true);
                        setPosts([...progressPosts]);

                        return result;
                    })
                );
                
                const newPosts = results.filter(r => !!r?.value).map(r => r.value)?.flat();
                const finalPosts = generateMore ? [...(posts || []), ...(newPosts || [])] : newPosts;
                
                setPosts(finalPosts);
                // Complete the generation
                completeGeneration(finalPosts);
                
            } catch (error) {
                console.error('Generation failed:', error);
                // Don't cancel automatically, let user decide
                updateGenerationProgress(posts, false);
            }
        }
        
        setIsLoading(false);
    }

    useEffect(() => {
        if (config?.postType) {
            localStorage.setItem(`postConfig.postType.${template}`, config?.postType);
            setConfig({ ...config, prompts: defaultPrompts.filter(p => p.social_network_type === config?.postType) });
        }
        if (config?.imageType) {
            localStorage.setItem(`postConfig.imageType.${template}`, config?.imageType);
        }
    }, [config?.postType, config?.imageType]);

    useEffect(() => {
        setPosts([]);
        if (!imageTypes?.includes(config?.imageType)) {
            setConfig({ ...config, imageType: imageTypes[0].value })
        }
    }, [template, company?.id]);

    // Restore active generation if user navigates back to the same template
    useEffect(() => {
        if (activeGeneration && activeGeneration.template === template) {
            // Restore posts if they exist
            if (activeGeneration.posts?.length > 0) {
                setPosts(activeGeneration.posts);
            }
            
            // Always restore loading state for active generations
            setIsLoading(activeGeneration.isLoading);
            
            // Don't restore contexts from activeGeneration as they might be mock contexts
            // The lastContexts should already be stored correctly from the original generation
        }
    }, [activeGeneration, template]);

    useEffect(() => {
        setConfig({ 
            ...config, 
            prompts: defaultPrompts.filter(p => p.social_network_type === config?.postType) 
        })
    }, [defaultPrompts])

    useEffect(() => {
        const postType = localStorage.getItem(`postConfig.postType.${template}`) || postTypes?.[0]?.value;
        setConfig({ 
            imageType: localStorage.getItem(`postConfig.imageType.${template}`) || getDefaultImageTypePerTemplate(template),
            postType: postType,
            tone: company?.language_type || undefined,
            prompts: defaultPrompts.filter(p => p.social_network_type === postType)
        });
    }, [company?.id]);

    useEffect(() => {
        if (!!config?.imageType && !imageTypes?.map(e => e.value)?.includes(config?.imageType)) {
            setConfig({...config, imageType: imageTypes?.[0]?.value})
        }
    }, [imageTypes]);

    useEffect(() => {
        let _scheduledPosts = [...(scheduledPosts || [])];
        _scheduledPosts = _scheduledPosts.sort((a,b) => new Date(b.created_at) - new Date(a.created_at));
        _scheduledPosts.length = Math.min(100, _scheduledPosts.length);
        const previousTopics = scheduledPosts?.filter(e => !!e?.topic)?.map(e => e?.topic);
        setPreviousContexts([...new Set([...(previousContexts || []), ...(previousTopics || [])])]);
    }, [scheduledPosts?.length]);
    
    // Check if current image model has isJob property
    const currentImageModel = aiModels?.find(model => 
        model.type === 'image' && 
        model.model === company?.ai_preferences?.image_model
    );
    const isJobBasedModel = currentImageModel?.isJob === true;
    const showJobInfo = (config?.imageType === "ai" && isJobBasedModel) || config?.imageType === "ai_video";

    if (!template) {
        return (
            <div className='flex flex-col lg:flex-row flex-1 h-full overflow-x-hidden'>
                <SocialNetworkSidePanel />
                <div className='w-full h-full overflow-y-auto p-6'>
                    <div className="mb-6 px-2">
                        <h3 className="flex items-center gap-2">
                            <BsStars className="text-primary-600 text-2xl" />
                            Content Creation Tools
                        </h3>
                        <p className="text-gray-500 dark:text-gray-400 mt-2">
                            Choose from our powerful AI-powered tools to create engaging social media content
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {tools.map((tool, index) => (
                            <Card 
                                key={index}
                                onClick={() => navigate(`${tool.id}`)}
                                className={`p-6 cursor-pointer hover:shadow-lg transition-shadow duration-200 flex flex-col gap-4 ${
                                    tool.requiresUpgrade ? 'opacity-60' : ''
                                }`}
                            >
                                <div className="flex items-start justify-between">
                                    <div className="flex flex-col gap-2">
                                        <div className="flex items-center gap-2">
                                            <h4 className="font-bold">
                                                <Trans i18nKey={tool.title} />
                                            </h4>
                                            {tool.requiresUpgrade && (
                                                <Badge className="bg-primary-600 text-white">
                                                    PRO
                                                </Badge>
                                            )}
                                        </div>
                                        <p className="text-sm text-tertiary-500 dark:text-gray-400 dark:text-gray-400">
                                            <Trans i18nKey={tool.description} />
                                        </p>
                                    </div>
                                    <div className="text-3xl text-primary-600">
                                        {tool.icon}
                                    </div>
                                </div>

                                {tool.requiresUpgrade && (
                                    <div className="mt-2 flex justify-end">
                                        <Button 
                                            variant="twoTone"
                                            size="sm"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate('/settings/subscription');
                                            }}
                                        >
                                            Upgrade
                                        </Button>
                                    </div>
                                )}
                            </Card>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='flex flex-col lg:flex-row flex-1 h-full overflow-x-hidden'>
            <SocialNetworkSidePanel 
                className={`${template == "chat" && `hidden lg:block`}`}
            />
            <div className='w-full h-full'>
                <div className='w-full h-full flex flex-col relative'>
                    <div className={`flex-1 h-full w-full !overflow-y-auto flex flex-col relative`}>
                        {isLoading || (activeGeneration?.isLoading && activeGeneration?.template === template)
                            ? <div className='flex-1 overflow-y-auto flex flex-col items-center justify-center gap-8 p-4 lg:p-6'>
                                <div className='gap-4 flex items-center flex-col justify-center text-center'>
                                    {!isWhitelabel ? (
                                        <Lottie 
                                            options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: generationAnimation,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                            width={300}
                                            isClickToPauseDisabled={true}
                                            style={{ pointerEvents: 'none' }}
                                        />
                                    ) : (
                                        <Lottie 
                                            options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: generationAnimationWhitelabel,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                            width={300}
                                            isClickToPauseDisabled={true}
                                            style={{ pointerEvents: 'none' }}
                                        />
                                    )}
                                    <h3 className='mega-title text-center !text-xl'>
                                        {activeGeneration?.isLoading && activeGeneration?.template === template 
                                            ? (posts?.length > 0 ? 'Generating more posts...' : 'Generation in progress...') 
                                            : 'Generating posts...'
                                        }
                                    </h3>
                                    <p className='text-sm'>
                                        {activeGeneration?.isLoading && activeGeneration?.template === template 
                                            ? <>You can leave this page and come back later to see the results.<br />{activeGeneration?.posts?.length || 0} of {activeGeneration?.progress?.total || 0} posts generated.</> 
                                            : isLoading && posts?.length > 0
                                                ? `Adding more posts to your ${posts?.length} existing posts...`
                                                : <>We are summoning the perfect posts.<br />You can leave this page and come back later to see the results</>
                                        }
                                    </p>

                                    {showJobInfo && (
                                        <div className='mt-4 p-4 bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800 rounded-lg max-w-md'>
                                            <p className='text-sm text-primary-700 dark:text-primary-300 text-center'>
                                                <strong>High-quality AI assets are being generated.</strong><br />
                                                This may take a few minutes to complete. Select a different model if you want to generate images faster.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            : <>
                                <ToolHeader 
                                    tool={tool} 
                                    posts={posts}
                                    setPosts={setPosts}
                                />
                                <div className='flex flex-1'>
                                    <div className={`flex-1 w-full ${template != "suggest" && `pb-24`} lg:pb-0`}>
                                        {!posts.length 
                                            ? <SelectedToolComponent 
                                                generatePostsFromContexts={handleOnGeneratePostsFromContext} 
                                                config={config}
                                                setConfig={setConfig}
                                            />
                                            : <Container className="!max-w-none min-h-[300px] px-4 lg:px-6 flex flex-col items-center justify-center gap-8 mt-8 pb-24 lg:pb-8">
                                                <div className='w-full'>
                                                    <PostArticles 
                                                        posts={posts}
                                                        goBack={() => {
                                                            setPosts([]);
                                                            clearGeneration();
                                                        }}
                                                        showGenerateMore={!!lastContexts?.length}
                                                        handleOnGenerateMore={() => !isLoading && handleOnGeneratePostsFromContext(undefined, undefined, undefined, true)}
                                                        isLoading={isLoading}
                                                    />
                                                </div>
                                            </Container>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Playground
